import React from 'react';

import { HeadWrapper } from '../../elements';
import CertificateContainer from '../../components/Certificate/CertificateContainer';
import PanelContainer from '../../components/PanelContainer';
import Main from '../../elements/Main/Main';

function CertificatesPage() {
  return (
    <>
      <HeadWrapper
        href="https://developer.staq.io/certificates"
      />
      <PanelContainer />
      <Main>
        <CertificateContainer />
      </Main>
    </>
  );
}

export default CertificatesPage;
